const checkForProfileInfoExistence = (userdata) => {
  if (userdata.usersData.profiles.length === 0) return false;
  if (!userdata.usersData.profiles[0].profileInfo) return false;
  return true;
};

export { checkForProfileInfoExistence };
